/*
 * diagnosis (schema)
 */
import { boolean, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"

export const diagnoses = schema.table("diagnoses", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- General ---
	name: varchar("name", { length: 256 }).notNull(),
	description: text("description"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
